import { render, staticRenderFns } from "./showOwnNum.vue?vue&type=template&id=1c558dac&scoped=true"
import script from "./showOwnNum.vue?vue&type=script&lang=js"
export * from "./showOwnNum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c558dac",
  null
  
)

export default component.exports